import {
  FooterNavigation as Navigation,
  mapBusinessUnit,
} from '@dfds-frontend/navigations'
import { useAppShellContext } from '../AppShellProvider'

const FooterNavigation = ({ businessUnit }) => {
  const bu = mapBusinessUnit(businessUnit)
  const { footerCollection } = useAppShellContext()

  const footerData = footerCollection.items.find(
    (navigations) => mapBusinessUnit(navigations.businessUnit) === bu,
  )

  return <Navigation footerData={footerData} />
}

export default FooterNavigation
